import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useRoutes,
  useNavigation,
  useLocation,
} from "react-router-dom";
import QualityTabs from "../../common-components/quality-tabs/QualityTabs";
import Round from "@components/Round/Round";
import Hog from "@components/HOG/Hog";
import Fillet from "@components/fillet/Fillet";
import Equipment from "@components/Equipment/Equipment";
import { Button } from "devextreme-react";

const QualityPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  console.log("locations", location.pathname);

  const handleBack = () => {
    if (window.history.length <= 2) {
      // No useful history, redirect to homepage or a known route
      navigate("/");
    } else {
      navigate(-1);
    }
  };
  return (
    <>
      <QualityTabs /> {/* Main Quality Tabs */}
      <Routes>
        <Route path="round" element={<Round />} />
        <Route path="hog" element={<Hog />} />
        <Route path="fillet/*" element={<Fillet />} /> {/* Nested Routes */}
        <Route path="equipment" element={<Equipment />} />
        <Route path="*" element={<Fillet />} /> {/* Default to Fillet */}
        {/* <Route path="*" element={<Navigate to="fillet" />} /> Default to Fillet */}
      </Routes>
      {/* <div className="flex items-center mb-3 mr-2">
        <Button
          icon="back"
          type="normal"
          stylingMode="text"
          disabled={["/quality/fillet/overview"].find((data) =>
            data.includes(location.pathname)
          )}
          onClick={handleBack}
        />
      </div> */}
    </>
  );
};

export default QualityPage;
